import React, { useRef, useEffect } from 'react';
import ChatInterface from '../components/ChatInterface';
import { streamManagerChat, saveQA } from '../services/managerService';
import { useModel } from '../contexts/ModelContext';
import { useAuth } from '../contexts/AuthContext';
import { logInteraction } from '../services/adminService';

function ManagerChat({ registerChatReset }) {
  const chatRef = useRef(null);
  const { selectedModel } = useModel();
  const { userEmail, userProfile } = useAuth();
  const sessionIdRef = useRef('manager-' + Date.now());

  useEffect(() => {
    if (registerChatReset && chatRef.current) {
      registerChatReset('/manager/chat', () => {
        chatRef.current.reset();
        sessionIdRef.current = 'manager-' + Date.now();
      });
    }
  }, [registerChatReset]);

  const handleSendMessage = async (question, conversationHistory, onMessage, onError, onComplete) => {
    await streamManagerChat(question, conversationHistory, onMessage, onError, onComplete, selectedModel, userEmail, userProfile, sessionIdRef.current);
  };

  const handleSaveQA = async (question, answer) => {
    await saveQA(question, answer, { 
      user: userEmail || 'anonymous',
      session_id: sessionIdRef.current,
      llm_model: selectedModel,
    });
  };

  const handleLogInteraction = async (data) => {
    await logInteraction({
      ...data,
      session_id: sessionIdRef.current,
      context_type: 'manager',
      model_key: selectedModel,
    });
  };

  return (
    <ChatInterface 
      ref={chatRef}
      onSendMessage={handleSendMessage}
      onSaveQA={handleSaveQA}
      onLogInteraction={handleLogInteraction}
      placeholder="Ask anything"
      title="Manager Agent"
      agentTitle="MANAGER AGENT"
    />
  );
}

export default ManagerChat;
